import { combineReducers } from 'redux'
import answersReducer from './answersReducer'

const rootReducer = combineReducers({
      answers: answersReducer,
})
export default rootReducer



// WEBPACK FOOTER //
// ./js/components/rootReducer.js